import { Component, OnInit, Inject, ElementRef, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotificationService } from 'src/app/shared/Notification.service';
import { DownloadService } from 'src/app/shared/Download.service';

import { ProductInfo } from 'src/app/shared/ProductInfo.model';
import { ProductInfoService } from 'src/app/shared/ProductInfo.service';

import { ProductInfoDocuments } from 'src/app/shared/ProductInfoDocuments.model';
import { ProductInfoDocumentsService } from 'src/app/shared/ProductInfoDocuments.service';

import { ThanhVien } from 'src/app/shared/ThanhVien.model';
import { ThanhVienService } from 'src/app/shared/ThanhVien.service';

import { CompanyInfo } from 'src/app/shared/CompanyInfo.model';
import { CompanyInfoService } from 'src/app/shared/CompanyInfo.service';

import { DanhMucATTPXepLoai } from 'src/app/shared/DanhMucATTPXepLoai.model';
import { DanhMucATTPXepLoaiService } from 'src/app/shared/DanhMucATTPXepLoai.service';
import { CompanyInfoDetailComponent } from '../company-info-detail/company-info-detail.component';

@Component({
  selector: 'app-product-info-detail001',
  templateUrl: './product-info-detail001.component.html',
  styleUrls: ['./product-info-detail001.component.css']
})
export class ProductInfoDetail001Component implements OnInit {

  @ViewChild('ProductInfoDocumentsSort') ProductInfoDocumentsSort: MatSort;
  @ViewChild('ProductInfoDocumentsPaginator') ProductInfoDocumentsPaginator: MatPaginator;
  @ViewChild('fileInput', { static: false }) fileInput!: ElementRef;

  constructor(
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<ProductInfoDetail001Component>,
    @Inject(MAT_DIALOG_DATA) public data: any,

    public NotificationService: NotificationService,
    public DownloadService: DownloadService,

    public ProductInfoService: ProductInfoService,
    public ProductInfoDocumentsService: ProductInfoDocumentsService,

    public ThanhVienService: ThanhVienService,
    public CompanyInfoService: CompanyInfoService,

    public DanhMucATTPXepLoaiService: DanhMucATTPXepLoaiService,
  ) { }

  ngOnInit(): void {
    this.CheckIsConfirm();
    this.CompanyInfoSearch();
    this.DanhMucATTPXepLoaiSearch();
    this.ThanhVienGetLogin();
    this.ProductInfoDocumentsSearch();
  }
  DisableForm: boolean = false;
  CheckIsConfirm(){
    if(this.ProductInfoService.FormData.ID>0){
      this.DisableForm = this.ProductInfoService.FormData.Active === true ? true : false ;
      return;
    }
    this.DisableForm = false;
  }
  DateNgayGhiNhan(value) {
    this.ProductInfoService.FormData.NgayGhiNhan = new Date(value);
  }
  DanhMucATTPXepLoaiSearch() {
    this.DanhMucATTPXepLoaiService.ComponentGetAllToListAsync();
  }  
  CompanyInfoSearch() {
    this.CompanyInfoService.ComponentGet000ToListAsync();
  }
  CompanyInfoFilter(searchString: string) {
    this.CompanyInfoService.Filter000(searchString);
  }
  CompanyInfoAdd(ID: number) {
    this.ProductInfoService.IsShowLoading = true;
    this.CompanyInfoService.BaseParameter.ID = ID;
    this.CompanyInfoService.GetByIDAsync().subscribe(
      res => {
        this.CompanyInfoService.FormData = res as CompanyInfo;      
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.width = environment.DialogConfigWidth;
        dialogConfig.data = { ID: ID };
        const dialog = this.dialog.open(CompanyInfoDetailComponent, dialogConfig);
        dialog.afterClosed().subscribe(() => {
          this.CompanyInfoSearch();
        });
        this.ProductInfoService.IsShowLoading = false;
      },
      err => {
        this.ProductInfoService.IsShowLoading = false;
      }
    );
  }
  ThanhVienGetLogin() {
    this.ThanhVienService.GetLogin();
  }  
  ProductInfoSave() {
    // Chặn save trên mobile
    if (this.NotificationService.blockMobileActionIfNeeded()) {
      return;
    }
    
    this.ProductInfoService.FormData.ParentID = this.ThanhVienService.FormDataLogin.CompanyInfoID;
    this.ProductInfoService.IsShowLoading = true;
    this.ProductInfoService.SaveAsync().subscribe(
      res => {
        this.ProductInfoService.FormData = res as ProductInfo;
        if (this.ProductInfoService.FormData) {
          if (this.ProductInfoService.FormData.ID) {
            if (this.ProductInfoDocumentsService.FileToUpload) {
              if (this.ProductInfoDocumentsService.FileToUpload.length > 0) {
                this.ProductInfoDocumentsService.FormData.ParentID = this.ProductInfoService.FormData.ID;
                this.ProductInfoDocumentsService.FormData.Name = this.ProductInfoService.FormData.Name;
                this.ProductInfoDocumentsService.FormData.Code = this.ProductInfoService.FormData.Code;
                this.ProductInfoDocumentsService.SaveAndUploadFileAsync().subscribe(
                  res => {
                    this.ProductInfoDocumentsSearch();
                    this.ProductInfoService.IsShowLoading = false;
                    this.NotificationService.warn(environment.SaveSuccess);
                  },
                  err => {
                    this.ProductInfoService.IsShowLoading = false;
                    this.NotificationService.warn(environment.SaveNotSuccess);
                  }
                );

              }else{
                this.ProductInfoService.IsShowLoading = false;
                this.NotificationService.warn(environment.SaveSuccess);
              }
            }else{
              this.ProductInfoService.IsShowLoading = false;
              this.NotificationService.warn(environment.SaveSuccess);
            }
          }else{
            this.NotificationService.warn(environment.SaveNotSuccess);
            this.ProductInfoService.IsShowLoading = false;
          }
        }else{
          this.ProductInfoService.IsShowLoading = false;
          this.NotificationService.warn(environment.SaveNotSuccess);
        }
      },
      err => {
        this.NotificationService.warn(environment.SaveNotSuccess);
        this.ProductInfoService.IsShowLoading = false;
      }
    );
  }
  ChangeFileName(files: FileList) {
    if (files) {
      this.ProductInfoDocumentsService.FileToUpload = files;
    }
  }
  openFileInput(){
    this.fileInput.nativeElement.click();
  }

  publicDoc: ProductInfoDocuments;
  ProductInfoDocumentsSearch() {
    this.ProductInfoService.IsShowLoading = true;
    this.ProductInfoDocumentsService.BaseParameter.ParentID = this.ProductInfoService.FormData.ID;
    this.ProductInfoDocumentsService.GetByParentIDAndEmptyToListAsync().subscribe(
      res => {
        this.ProductInfoDocumentsService.List = (res as ProductInfoDocuments[]).sort((a, b) => (a.ID < b.ID ? 1 : -1));
        this.publicDoc = this.ProductInfoDocumentsService.List.find(p=>p.FileName !== null && p.FileName !== undefined && this.ProductInfoService.FormData.ID > 0);
        this.ProductInfoDocumentsService.DataSource = new MatTableDataSource(this.ProductInfoDocumentsService.List);
        this.ProductInfoDocumentsService.DataSource.sort = this.ProductInfoDocumentsSort;
        this.ProductInfoDocumentsService.DataSource.paginator = this.ProductInfoDocumentsPaginator;
        this.ProductInfoService.IsShowLoading = false;
      },
      err => {
        this.ProductInfoService.IsShowLoading = false;
      }
    );
  }
  
  isPDFFile(fileName: string): boolean {
    return /\.pdf$/i.test(fileName);
  }
  isWordOrExcelFile(fileName: string): boolean {
    return /\.(doc|docx|xlsx)$/i.test(fileName);
  }
  isHtmlFile(fileName: string): boolean {
    return /\.(html)$/i.test(fileName);
  }

  /**
   * Fix file URL: thay localhost:5129 thành IP từ environment hoặc 10.0.2.2 cho emulator
   */
  fixFileUrl(fileUrl: string): string {
    if (!fileUrl) {
      return fileUrl;
    }

    try {
      // Nếu URL chứa localhost:5129, thay bằng IP từ environment
      if (fileUrl.includes('localhost:5129')) {
        // Trên Cordova (Android), nếu đang dùng emulator thì dùng 10.0.2.2
        // Nhưng vì đã cấu hình IP thực 192.168.1.50, nên dùng IP đó
        const isCordovaEnv = !!(window as any).cordova;
        if (isCordovaEnv) {
          // Trên Android emulator, localhost không hoạt động
          // Thay bằng IP từ APIRootURL hoặc 10.0.2.2 cho emulator
          // Nhưng vì đã dùng IP thực, nên thay trực tiếp
          const apiRootUrl = environment.APIRootURL || 'http://192.168.1.50:5129/';
          const apiHost = apiRootUrl.replace(/^https?:\/\//, '').replace(/\/$/, '');
          fileUrl = fileUrl.replace(/localhost:5129/g, apiHost);
          console.log('[ProductInfoDetail001] Fixed URL for Cordova:', fileUrl);
        } else {
          // Web: thay bằng IP từ environment
          const apiRootUrl = environment.APIRootURL || 'http://192.168.1.50:5129/';
          const apiHost = apiRootUrl.replace(/^https?:\/\//, '').replace(/\/$/, '');
          fileUrl = fileUrl.replace(/localhost:5129/g, apiHost);
        }
      }
      
      // Nếu URL là relative path (bắt đầu bằng /), build URL đầy đủ
      if (fileUrl.startsWith('/') && !fileUrl.startsWith('//')) {
        const apiRootUrl = environment.APIRootURL || 'http://192.168.1.50:5129/';
        fileUrl = apiRootUrl.replace(/\/$/, '') + fileUrl;
      }

      // Chuẩn hoá tên miền cũ -> mới (áp dụng cho mọi link view/download)
      fileUrl = fileUrl.replace('bentre.gov.vn', 'vinhlong.gov.vn');
      
      return fileUrl;
    } catch (error) {
      console.error('[ProductInfoDetail001] Error fixing file URL:', error);
      return fileUrl; // Trả về URL gốc nếu có lỗi
    }
  }

  getMimeType(fileName: string): string {
    if (fileName.endsWith('.pdf')) return 'application/pdf';
    if (fileName.endsWith('.doc')) return 'application/msword';
    if (fileName.endsWith('.docx')) return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
    if (fileName.endsWith('.xls')) return 'application/vnd.ms-excel';
    if (fileName.endsWith('.xlsx')) return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    return '*/*';
  }

  openDownload(fileName: string): void {
    if (!fileName) {
      return;
    }

    try {
      const isCordovaEnv = !!(window as any).cordova;
      const fixedUrl = this.fixFileUrl(fileName);

      console.log('[ProductInfoDetail001] openDownload clicked, fileName =', fileName, 'fixedUrl =', fixedUrl, 'isCordovaEnv =', isCordovaEnv);

      if (isCordovaEnv) {
        // Android: Download file về local trước khi mở
        this.downloadAndOpenFile(fixedUrl, false);
      } else {
        // Web: mở tab mới như behavior cũ
        window.open(fixedUrl, '_blank');
      }
    } catch (error) {
      console.error('Error opening file:', error);
      this.NotificationService.warn('Không thể mở tập tin. Vui lòng thử lại trên trình duyệt.');
    }
  }

  openView(fileName: string): void {
    if (!fileName) {
      return;
    }

    const isCordovaEnv = !!(window as any).cordova;
    const fixedUrl = this.fixFileUrl(fileName);

    // Web: mở tab mới bình thường
    if (!isCordovaEnv) {
      window.open(fixedUrl, '_blank');
      return;
    }

    try {
      console.log('[ProductInfoDetail001] openView (Cordova) clicked, fileName =', fileName, 'fixedUrl =', fixedUrl);

      // Android: Download file về local trước khi mở (giống openDownload)
      this.downloadAndOpenFile(fixedUrl, true);
    } catch (error) {
      console.error('Error opening file from openView:', error);
      this.NotificationService.warn('Không thể xem tập tin. Vui lòng thử lại trên trình duyệt.');
    }
  }

  downloadAndOpenFile(fileUrl: string, isView: boolean): void {
    try {
      const cordova = (window as any).cordova;
      const fileTransfer = (window as any).FileTransfer;

      // Kiểm tra FileTransfer plugin và cordova.file (không phải window.File)
      if (!fileTransfer || !cordova || !cordova.file) {
        console.warn('[ProductInfoDetail001] FileTransfer or File plugin not available', {
          hasFileTransfer: !!fileTransfer,
          hasCordova: !!cordova,
          hasCordovaFile: !!(cordova && cordova.file)
        });
        // Fallback: nếu là HTTPS URL thì không thể mở trực tiếp
        if (fileUrl.startsWith('http://') || fileUrl.startsWith('https://')) {
          this.NotificationService.warn('Không thể tải file. Plugin FileTransfer chưa được cài đặt.');
          return;
        }
        // Thử mở trực tiếp (có thể là file local)
        this.openFileDirectly(fileUrl);
        return;
      }

      // Lấy tên file từ URL
      const fileName = fileUrl.substring(fileUrl.lastIndexOf('/') + 1);
      const fileExtension = fileName.substring(fileName.lastIndexOf('.'));
      
      // Đường dẫn lưu file tạm
      const filePath = cordova.file.externalCacheDirectory || cordova.file.cacheDirectory;
      if (!filePath) {
        console.error('[ProductInfoDetail001] Cannot determine file cache directory');
        this.NotificationService.warn('Không thể xác định thư mục lưu file. Vui lòng kiểm tra quyền truy cập.');
        return;
      }
      
      const targetPath = filePath + fileName;

      console.log('[ProductInfoDetail001] Downloading file from', fileUrl, 'to', targetPath);

      // Hiển thị thông báo đang tải (nếu là download)
      if (!isView) {
        this.NotificationService.warn('Đang tải file...');
      }

      const transfer = new fileTransfer();
      
      transfer.download(
        fileUrl,
        targetPath,
        (entry: any) => {
          // Sử dụng nativeURL để lấy đường dẫn file thực tế (file:///...)
          // Thay vì toURL() trả về Cordova file URL (https://app/__cdvfile_...)
          const filePath = entry.nativeURL || entry.toInternalURL() || entry.toURL();
          console.log('[ProductInfoDetail001] Download success:', filePath);
          // Mở file sau khi download
          this.openFileDirectly(filePath);
        },
        (error: any) => {
          console.error('[ProductInfoDetail001] Download error:', error);
          const errorCode = error?.code || error?.status || 'UNKNOWN';
          let errorMessage = 'Không thể tải file.';
          
          // Hiển thị thông báo chi tiết hơn dựa vào error code
          if (errorCode === 1 || errorCode === 'FILE_NOT_FOUND') {
            errorMessage = 'Không tìm thấy file trên server. File có thể đã bị xóa hoặc không tồn tại.';
          } else if (errorCode === 2 || errorCode === 'INVALID_URL') {
            errorMessage = 'URL không hợp lệ. Vui lòng kiểm tra lại đường dẫn file.';
          } else if (errorCode === 3 || errorCode === 'CONNECTION_ERR') {
            errorMessage = 'Lỗi kết nối. Vui lòng kiểm tra kết nối internet và thử lại.';
          } else {
            errorMessage = `Không thể tải file (Lỗi: ${errorCode}). Vui lòng thử lại.`;
          }
          
          this.NotificationService.warn(errorMessage);
          
          // Nếu download thất bại và là file local, thử mở trực tiếp
          if (!fileUrl.startsWith('http://') && !fileUrl.startsWith('https://')) {
            this.openFileDirectly(fileUrl);
          }
        },
        false,
        {
          headers: {}
        }
      );
    } catch (error) {
      console.error('[ProductInfoDetail001] Error in downloadAndOpenFile:', error);
      this.NotificationService.warn('Lỗi khi xử lý file. Vui lòng thử lại.');
    }
  }

  openFileDirectly(filePath: string): void {
    try {
      const cordova = (window as any).cordova;
      
      console.log('[ProductInfoDetail001] Opening file:', filePath);
      
      // Kiểm tra xem filePath có phải là HTTPS/HTTP URL thực sự không (không phải Cordova file URL)
      // Cordova file URL có dạng: https://app/__cdvfile_sdcard__/... hoặc cdvfile://...
      // File path thực tế có dạng: file:///storage/emulated/0/...
      if (filePath.startsWith('http://') || filePath.startsWith('https://')) {
        // Nếu là Cordova file URL (chứa __cdvfile__), cần resolve sang file path thực tế
        if (filePath.includes('__cdvfile__') || filePath.includes('cdvfile://')) {
          // Thử resolve Cordova file URL sang file path thực tế
          if (cordova && cordova.file && cordova.file.resolveLocalFileSystemURL) {
            cordova.file.resolveLocalFileSystemURL(filePath, 
              (entry: any) => {
                const realPath = entry.nativeURL || entry.toInternalURL();
                console.log('[ProductInfoDetail001] Resolved Cordova URL to:', realPath);
                this.openFileDirectly(realPath);
              },
              (error: any) => {
                console.error('[ProductInfoDetail001] Cannot resolve Cordova file URL:', error);
                this.NotificationService.warn('Không thể mở file. Vui lòng thử lại.');
              }
            );
            return;
          } else {
            // Fallback: thử convert thủ công từ Cordova URL sang file path
            // https://app/__cdvfile_sdcard__/Android/data/... -> file:///storage/emulated/0/Android/data/...
            const convertedPath = filePath.replace(/https:\/\/app\/__cdvfile_sdcard__\//, 'file:///storage/emulated/0/');
            if (convertedPath !== filePath && convertedPath.startsWith('file://')) {
              console.log('[ProductInfoDetail001] Converted Cordova URL to:', convertedPath);
              filePath = convertedPath;
            } else {
              console.warn('[ProductInfoDetail001] Cannot open HTTPS URL directly, need to download first');
              this.NotificationService.warn('Không thể mở file từ URL. Vui lòng thử tải về trước.');
              return;
            }
          }
        } else {
          // Là HTTPS/HTTP URL thực sự, không thể mở trực tiếp
          console.warn('[ProductInfoDetail001] Cannot open HTTPS URL directly, need to download first');
          this.NotificationService.warn('Không thể mở file từ URL. Vui lòng thử tải về trước.');
          return;
        }
      }
      
      cordova.plugins.fileOpener2.open(
        filePath,
        this.getMimeType(filePath),
        {
          error: (e: any) => {
            console.error('[ProductInfoDetail001] Open error:', e);
            const errorCode = e?.status || e?.code || 'UNKNOWN';
            let errorMessage = 'Không thể mở file.';
            
            // Hiển thị thông báo chi tiết hơn dựa vào error code
            if (errorCode === 1 || errorCode === 'FILE_NOT_FOUND') {
              errorMessage = 'Không tìm thấy file. File có thể đã bị xóa hoặc không tồn tại.';
            } else if (
              errorCode === 9 || // Activity not found / No activity to handle intent
              errorCode === 5 || // NO_APP_FOUND theo tài liệu plugin
              errorCode === 10 ||
              errorCode === 'NO_APP_FOUND'
            ) {
              errorMessage = 'Không có ứng dụng để mở file này. Vui lòng cài ứng dụng phù hợp (PDF Viewer, Word, Excel).';
            } else {
              errorMessage = `Không thể mở file (Lỗi: ${errorCode}). Vui lòng thử lại hoặc cài ứng dụng phù hợp (PDF Viewer, Word, Excel).`;
            }
            
            this.NotificationService.warn(errorMessage);
          },
          success: () => {
            console.log('[ProductInfoDetail001] File opened successfully');
          }
        }
      );
    } catch (error) {
      console.error('[ProductInfoDetail001] Error opening file directly:', error);
      this.NotificationService.warn('Không thể mở tập tin. Vui lòng thử lại trên trình duyệt.');
    }
  }
  
  getViewerUrl(fileName: string): string {
    if (this.isPDFFile(fileName) || this.isHtmlFile(fileName)) {
      return fileName;
    } else{
      return this.changeExtensionToPdf(fileName);
    }
  }
  changeExtensionToPdf(url: string): string {
    try {
      const urlObj = new URL(url); // parse url
      const path = urlObj.pathname; // lấy phần path
      
      // tách tên file
      const lastDotIndex = path.lastIndexOf(".");
      if (lastDotIndex !== -1) {
        const ext = path.substring(lastDotIndex + 1).toLowerCase();
        if (ext !== "pdf") {
          urlObj.pathname = path.substring(0, lastDotIndex) + ".pdf";
        }
      } else {
        // nếu không có extension thì thêm luôn .pdf
        urlObj.pathname = path + ".pdf";
      }
      return urlObj.toString();
    } catch {
      // nếu url không hợp lệ thì xử lý chuỗi bình thường
      if (url.includes(".")) {
        return url.replace(/\.[^/.]+$/, ".pdf");
      }
      return url + ".pdf";
    }
  }
  ProductInfoDocumentsSave(element: ProductInfoDocuments) {
    this.ProductInfoService.IsShowLoading = true;
    element.ParentID = this.ProductInfoService.FormData.ID;
    element.Name = this.ProductInfoService.FormData.Name;
    element.Code = this.ProductInfoService.FormData.Code;
    this.ProductInfoDocumentsService.FormData = element;
    this.ProductInfoDocumentsService.SaveAndUploadFileAsync().subscribe(
      res => {
        this.ProductInfoDocumentsSearch();
        this.NotificationService.warn(environment.SaveSuccess);
        this.ProductInfoService.IsShowLoading = false;
      },
      err => {
        this.NotificationService.warn(environment.SaveNotSuccess);
        this.ProductInfoService.IsShowLoading = false;
      }
    );
  }
  ProductInfoDocumentsDelete(element: ProductInfoDocuments) {
    if (confirm(environment.DeleteConfirm)) {
      this.ProductInfoService.IsShowLoading = true;
      this.ProductInfoDocumentsService.BaseParameter.ID = element.ID;
      this.ProductInfoDocumentsService.RemoveAsync().subscribe(
        res => {
          this.ProductInfoDocumentsSearch();
          this.NotificationService.warn(environment.SaveSuccess);
          this.ProductInfoService.IsShowLoading = false;
        },
        err => {
          this.NotificationService.warn(environment.SaveNotSuccess);
          this.ProductInfoService.IsShowLoading = false;
        }
      );
    }
  }
  Close() {
    this.dialogRef.close();
  }
}
